var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ConfirmationModal",
    {
      attrs: {
        entity: _vm.number,
        title: _vm.$t("PAUSE_NUMBER_MODAL_TITLE"),
        "cancel-button-text": _vm.$t("CANCEL"),
        "confirm-action-text": _vm.$t("PAUSE")
      },
      on: {
        confirm: _vm.confirmPause,
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("i18n", {
        attrs: { path: "PAUSE_NUMBER_MODAL_TEXT", tag: "p" },
        scopedSlots: _vm._u([
          {
            key: "phone",
            fn: function() {
              return [_c("strong", [_vm._v(_vm._s(_vm.number.displayNumber))])]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }